import { Route } from "@angular/router";
import { MaintenanceComponent } from "./maintenance.component";

export const MaintenanceRouting: Route = {
    path: 'maintenance', component: MaintenanceComponent
};